"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  id: 1,
  name: "Cambridge Assessment English",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/cambridge_assessment_logo.png"
}, {
  id: 2,
  name: "British Council",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/british_council_logo.png"
}, {
  id: 3,
  name: "Goethe Institut",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/goethe_institut_logo.png"
}, {
  id: 4,
  name: "TOEFL Official",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/toefl_official_logo.png"
}, {
  id: 5,
  name: "ETS Global",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/ets_global_logo.png"
}, {
  id: 6,
  name: "TestDaF Institute",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/testdaf_institute_logo.png"
}, {
  id: 7,
  name: "IELTS Partners",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/ielts_partners_logo.png"
}, {
  id: 8,
  name: "European Language Centre",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/european_language_centre_logo.png"
}];
export default function PartnerLogos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="partner-logos" className="dark bg-background text-foreground py-20 px-6 md:px-8" ref={ref}>
      <div className="container max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className={`font-display text-4xl md:text-5xl font-bold text-foreground mb-4 transition-all duration-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            Our Trusted Partners
          </h2>
          <p className={`text-muted-foreground text-lg max-w-2xl mx-auto transition-all duration-300 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            We collaborate with leading international educational organizations to ensure the highest quality language training and certification.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {partners.map((partner, i) => <div key={partner.id} data-index={i} className={`flex items-center justify-center p-6 transition-all duration-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: isVisible ? `${(i + 2) * 50}ms` : "0ms"
        }}>
              <img src={partner.logo} alt={partner.name} className="w-full h-auto max-h-20 object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-150" />
            </div>)}
        </div>
      </div>
    </section>;
}